import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import './FAQPage.css';

const FAQ_STRUCTURE = [
  {
    key: 'getting-started',
    catKey: 'gettingStarted',
    items: [
      { qKey: 'gs0q', aKey: 'gs0a' },
      { qKey: 'gs1q', aKey: 'gs1a' },
      { qKey: 'gs2q', aKey: 'gs2a' },
    ],
  },
  {
    key: 'buying-renting',
    catKey: 'buyingRenting',
    items: [
      { qKey: 'br0q', aKey: 'br0a' },
      { qKey: 'br1q', aKey: 'br1a' },
      { qKey: 'br2q', aKey: 'br2a' },
      { qKey: 'br3q', aKey: 'br3a' },
      { qKey: 'br4q', aKey: 'br4a' },
      { qKey: 'br5q', aKey: 'br5a' },
    ],
  },
  {
    key: 'listing-property',
    catKey: 'listingProperty',
    items: [
      { qKey: 'lp0q', aKey: 'lp0a' },
      { qKey: 'lp1q', aKey: 'lp1a' },
      { qKey: 'lp2q', aKey: 'lp2a' },
    ],
  },
  {
    key: 'pro-boost',
    catKey: 'proBoost',
    items: [
      { qKey: 'pb0q', aKey: 'pb0a' },
      { qKey: 'pb1q', aKey: 'pb1a' },
      { qKey: 'pb2q', aKey: 'pb2a' },
      { qKey: 'pb4q', aKey: 'pb4a' },
    ],
  },
  {
    key: 'privacy-safety',
    catKey: 'privacySafety',
    items: [
      { qKey: 'ps1q', aKey: 'ps1a' },
      { qKey: 'ps2q', aKey: 'ps2a' },
    ],
  },
];

function ChevronIcon() {
  return (
    <svg
      className="faqPage__chevron"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
}

export default function FAQPage() {
  const [openKey, setOpenKey] = useState(null);
  const { t } = useLanguage();

  const toggle = (key) => setOpenKey(prev => (prev === key ? null : key));

  return (
    <main className="faqPage">

      <div className="faqPage__hero">
        <div className="faqPage__hero-inner">
          <span className="faqPage__badge">
            <span className="faqPage__badge-dot" />
            {t('faq.badge')}
          </span>
          <h1 className="faqPage__title">{t('faq.title')}</h1>
          <p className="faqPage__subtitle">{t('faq.subtitle')}</p>
        </div>
      </div>

      <div className="faqPage__body">
        {FAQ_STRUCTURE.map((cat) => (
          <section key={cat.key} className="faqPage__section">
            <h2 className="faqPage__cat-label">{t(`faq.cat.${cat.catKey}`)}</h2>
            <div className="faqPage__items">
              {cat.items.map((item, ii) => {
                const key = `${cat.key}-${ii}`;
                const isOpen = openKey === key;
                return (
                  <div
                    key={key}
                    className={`faqPage__item${isOpen ? ' faqPage__item--open' : ''}`}
                  >
                    <button
                      className="faqPage__question"
                      onClick={() => toggle(key)}
                      aria-expanded={isOpen}
                    >
                      <span>{t(`faq.items.${item.qKey}`)}</span>
                      <ChevronIcon />
                    </button>
                    <div className="faqPage__answer-wrap" aria-hidden={!isOpen}>
                      <div className="faqPage__answer">
                        <p>{t(`faq.items.${item.aKey}`)}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>
        ))}
      </div>

    </main>
  );
}
